import React, { useState, useEffect } from 'react';
import * as api from '../../services/api';
import {
    Container,
    Typography,
    Paper,
    Box,
    TextField,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Stack,
    IconButton,
    Tooltip
} from '@mui/material';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";


const SourceSystems = () => {
    const [systems, setSystems] = useState([]);
    const [newSystemName, setNewSystemName] = useState('');
    const [newSystemDescription, setNewSystemDescription] = useState('');

    const fetchSystems = async () => {
        const response = await api.getSourceSystems();
        setSystems(response.data);
    };

    useEffect(() => {
        fetchSystems();
    }, []);

    const handleCreate = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!newSystemName) return;
        await api.createSourceSystem(newSystemName, newSystemDescription);
        setNewSystemName('');
        setNewSystemDescription('');
        fetchSystems(); // refresh list
    };

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Administration: Quellsysteme
            </Typography>

            {/* New system form */}
            <Paper sx={{ p: 3, mb: 4 }}>
                <Typography variant="h6" gutterBottom>
                    Neues System anlegen
                </Typography>
                <Box component="form" onSubmit={handleCreate} noValidate>
                    <Stack spacing={2}>
                        <TextField
                            label="Name des Systems (z.B. Moodle)"
                            value={newSystemName}
                            onChange={(e) => setNewSystemName(e.target.value)}
                            required
                            fullWidth
                        />
                        <TextField
                            label="Aussagekräftige Beschreibung des Systems"
                            value={newSystemDescription}
                            onChange={(e) => setNewSystemDescription(e.target.value)}
                            multiline
                            rows={4}
                            required
                            fullWidth
                        />
                        <Button type="submit" variant="contained" color="primary">
                            Erstellen
                        </Button>
                    </Stack>
                </Box>
            </Paper>

            {/* Existing systems table */}
            <Paper sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom>
                    Bestehende Systeme
                </Typography>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Beschreibung</TableCell>
                            <TableCell>Bearer Token</TableCell>
                            <TableCell>&nbsp;</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {systems.map((system) => (
                            <TableRow key={system.token}>
                                <TableCell>{system.name}</TableCell>
                                <TableCell>{system.description}</TableCell>
                                <TableCell>
                                    <code>{system.token}</code>
                                </TableCell>
                                <TableCell>
                                    <Tooltip title="Token kopieren">
                                        <IconButton
                                            size="small"
                                            onClick={() => {
                                                // Fallback für ältere Browser
                                                if (navigator?.clipboard?.writeText) {
                                                    navigator.clipboard.writeText(system.token);
                                                } else {
                                                    const textarea = document.createElement("textarea");
                                                    textarea.value = system.token;
                                                    textarea.style.position = "fixed"; // avoid scrolling to bottom
                                                    document.body.appendChild(textarea);
                                                    textarea.focus();
                                                    textarea.select();
                                                    try {
                                                        document.execCommand("copy");
                                                    } finally {
                                                        document.body.removeChild(textarea);
                                                    }
                                                }
                                            }}
                                            sx={{ ml: 1 }}
                                        >
                                            <ContentCopyIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </Container>
    );
};

export default SourceSystems;
